import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectEmployerName = (state) =>
  createApplicationFormSelector(state, 'employer_name');
